import { Rect } from 'react-konva';
import { useStore } from '~/store';
import { WM_COLOR } from './colors';

export function WatermarkOverlay() {
  const region = useStore((s) => s.watermark.region);
  const enabled = useStore((s) => s.watermark.enabled);
  if (!enabled || !region) return null;
  return (
    <Rect
      x={region.x}
      y={region.y}
      width={region.w}
      height={region.h}
      stroke={WM_COLOR}
      strokeWidth={2}
      dash={[6, 4]}
      strokeScaleEnabled={false}
      fill="rgba(233,75,111,0.10)"
      listening={false}
    />
  );
}
